//!#system	

<template>
	<img :src="src" alt="" :height="dims.height">
</template>

<script>
import apiService from '@/apiService';

export default {
	name: "AppLogo",
	props: ['height', 'width'],
	data() {
		return {
			// empty image
			src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
		}
	},
	computed: {
		dims() {
			return {
				height: this.height || 50,
				width: this.width || 130
			}
		}
	},
	created() {
		apiService.image({
			url: '/_sys/internals/app-info/app-logo'
		}, (err, data) => {
			if(err) return null;
			let imageData = data['image'].data;
			let bytes = new Uint8Array(imageData);
			let binary = bytes.reduce((data, b) => data += String.fromCharCode(b), '');
			this.src = "data:image/png;base64," + btoa(binary);
		});
	}
};
</script>